import styles from './ResultQuiz.module.css';

export const ResultQuiz = ({ playerSrc }) => {
  return (
    <div className={styles.wrapper}>
      {playerSrc && (
        <video muted="muted" playsInline loop autoPlay>
          <source src={playerSrc} type="video/webm"></source>
        </video>
      )}
    </div>
  );
};
